import { SP360IconLogo } from 'assets';
import LoadingScreen from 'components/LoadingScreen';
import { useAtomValue } from 'jotai';
import callApi from 'lib/callApi';
import QRCode from 'qrcode.react';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  Form,
  Input,
  Label,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

import history from '../history';
import { companyIdAtom } from './state';

export const AuthenticationMethod = {
  Email: 'email',
  TOTP: 'totp',
};

class UserProfileInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      username: '',
      password: '',
      url: undefined,
      otp: '',
      mfaModal: false,
      userEmailModel: false,
      password_verified: false,
      authentication_method: '',
      confirmationModal: false,
      openNotificationModal: false,
    };
  }
  componentDidMount() {
    void this.fetchProfile.bind(this)();
  }

  // Refetch when company changes
  componentDidUpdate(prevProps) {
    if (prevProps.companyId !== this.props.companyId) {
      void this.fetchProfile();
    }
  }

  async verifyTOTPForMFAMethod() {
    let url = `profiles/verify-totp-code/`;
    await callApi(url, 'POST', {}, { otp: this.state.otp })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          this.setState({ mfaModal: false });
          toast.success('MFA authentication method updated successfully.');
        } else {
          // eslint-disable-next-line no-console
          console.error({
            function: 'verifyTOTPForMFAMethod',
            error: `Unexpected response: ${res.status}`,
            res,
          });
        }
      })
      .catch((err) => {
        // read the response http status and if its 400, then show an invalid otp message
        // eslint-disable-next-line no-console
        console.error(err);
        if (err.status === 400) {
          toast.error('Invalid OTP code, please try again.');
        } else {
          toast.error(
            err.data?.error || 'An error occurred while verifying the OTP.',
          );
        }
      });
  }

  async verifyOTPForEmailUpdate() {
    let data = {
      username: this.state.username,
      password: this.state.password,
      otp_code: this.state.otp,
      device_id: localStorage.getItem('device_uid'),
      email: this.state.newEmail,
    };
    let url = 'profiles/update-email/';
    await callApi(url, 'PUT', {}, data)
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            userEmailModel: false,
            password_verified: false,
          });
          this.setState({
            user: {
              ...this.state.user,
              email: this.state.newEmail,
              user: this.state.newEmail,
              label: this.state.newEmail,
            },
          });
          toast.success('Your profile has been successfully updated.', {});
        } else {
          // eslint-disable-next-line no-console
          console.error({
            function: 'verifyOTPForEmailUpdate',
            error: `Unexpected response: ${res.error}`,
            res,
          });
          toast.error(res.error);
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        if (err.data?.email) {
          toast.error('A username or email already exists with this email.');
        } else {
          toast.error(
            err.data?.error || 'An error occurred while updating the email.',
          );
        }
      });
  }

  async fetchProfile(currentUrl) {
    let url = `profiles/?company_id=${this.props.companyId}`;
    if (currentUrl) {
      url = currentUrl;
    }
    await callApi(url, 'GET', {})
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            let user = {};
            if (res.data.count === 1 || res.data.count === '1') {
              user = res.data.results[0];
            }
            this.setState({
              profile: res.data.results,
              user: user,
              authentication_method: user.authentication_method,
              count: res.data.count,
              nextUrl: res.data.next,
              previousUrl: res.data.previous,
            });
          } else {
            this.setState({ profile: [], count: 0 });
          }
          this.setState({ modal: false });
        } else if (res.status === 401 || res.status === 400) {
          history.push('/login');
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
          history.push('/login');
        }
      });
  }
  updateUserData(field, value) {
    let user = this.state.user;
    user[field] = value;
    this.setState({ user: user });
  }

  async updateProfile() {
    let url = `profiles/${this.state.user.value}/`;

    await callApi(
      url,
      'PUT',
      {},
      {
        first_name: this.state.user.first_name,
        last_name: this.state.user.last_name,
      },
    )
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          toast.success('Your profile has been successfully updated.', {});
        } else if (res.status === 422) {
          toast.error('Error! ' + res.data, {});
        } else if (res.status === 401 || res.status === 400) {
          history.push('/login');
        }
      })
      .catch((err) => {
        if (err.status === 422) {
          // Extract and display the first error message from the response
          const errorData = err.data;
          const firstKey = Object.keys(errorData)[0];
          const firstError = Array.isArray(errorData[firstKey])
            ? errorData[firstKey][0]
            : errorData[firstKey];
          toast.error('Error! ' + firstError, {});
        } else if (err.status === 401 || err.status === 400) {
          toast.error('Error! ' + err.data, {});
          history.push('/login');
        }
      });
    this.setState({
      authentication_method: this.state.user.authentication_method,
      confirmationModal: false,
    });
  }

  renderUpdateMFAMethods() {
    return (
      <>
        {this.state.mfaModal && (
          <Modal isOpen={this.state.mfaModal} size="md">
            <ModalHeader>
              {this.state.password_verified
                ? 'Set up authenticator app'
                : 'Confirm?'}
            </ModalHeader>
            <ModalBody>
              {this.state.password_verified &&
                this.state.user.totp_device_configured === true && (
                  <>
                    <p>
                      You have already configured an authenticator app for the
                      backend application. Please confirm whether you would like
                      to use the same app for this application?
                    </p>
                  </>
                )}

              {this.state.password_verified &&
                this.state.user.totp_device_configured === false && (
                  <>
                    <ul>
                      <li>
                        In the authenticator app tap the <strong>+</strong>
                      </li>
                      <li>
                        Choose <strong>Scan a QR Code</strong>
                      </li>
                    </ul>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <QRCode
                        value={this.state.url}
                        size={150}
                        style={{ margin: 'auto' }}
                      />
                    </div>
                    <FormGroup>
                      <p>Enter the 6-digit code you see in the app </p>
                      <Input
                        name="otp"
                        maxLength={6}
                        onChange={(event) =>
                          this.setState({ otp: event.target.value })
                        }
                        placeholder="OTP code"
                        type="text"
                      />
                    </FormGroup>
                  </>
                )}

              {this.state.password_verified === false && (
                <>{this.renderUserPasswordForm()}</>
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                size="sm"
                onClick={() => {
                  this.setState({ mfaModal: false });
                  if (
                    this.state.user.authentication_method ===
                    AuthenticationMethod.Email
                  ) {
                    this.updateUserData(
                      'authentication_method',
                      AuthenticationMethod.TOTP,
                    );
                  } else {
                    this.updateUserData(
                      'authentication_method',
                      AuthenticationMethod.Email,
                    );
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                size="sm"
                onClick={async () => {
                  if (
                    this.state.password_verified &&
                    this.state.user.totp_device_configured === false
                  ) {
                    void this.verifyTOTPForMFAMethod.bind(this)();
                  } else if (
                    this.state.password_verified &&
                    this.state.user.totp_device_configured === true
                  ) {
                    this.setState({ mfaModal: false, otp: undefined });
                    void this.verifyTOTPForMFAMethod.bind(this)();
                  } else {
                    await callApi(
                      `profiles/validate-user-credentials/`,
                      'POST',
                      {},
                      {
                        username: this.state.username,
                        password: this.state.password,
                        authentication_method:
                          this.state.user.authentication_method,
                      },
                    )
                      .then((res) => {
                        if (res.status === 201 || res.status === 200) {
                          if (
                            this.state.user.authentication_method ===
                            AuthenticationMethod.Email
                          ) {
                            this.setState({ mfaModal: false });
                            this.setState({
                              user: {
                                ...this.state.user,
                                authentication_method:
                                  AuthenticationMethod.Email.value,
                              },
                            });
                            toast.success(
                              'MFA authentication method changed to Email',
                            );
                          } else {
                            this.setState({ password_verified: true });
                            if (
                              this.state.user.totp_device_configured === false
                            ) {
                              this.setState({ url: res.data.url });
                            }
                          }
                        }
                      })
                      .catch(() => {
                        toast.error('Username or password incorrect');
                      });
                  }
                }}
              >
                Confirm
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </>
    );
  }

  renderUserPasswordForm() {
    return (
      <>
        <p>
          Please provide your login credentials to confirm the change of your
          2FA (MFA) authentication method:
        </p>
        <FormGroup>
          <p>Username</p>
          <Input
            name="username"
            onChange={(event) =>
              this.setState({ username: event.target.value })
            }
            placeholder="Username"
            type="text"
          />
          <p>Password</p>
          <Input
            name="password"
            onChange={(event) =>
              this.setState({ password: event.target.value })
            }
            placeholder="Password"
            type="password"
            autoComplete="new-password"
          />
        </FormGroup>
      </>
    );
  }

  renderEmailUpdateForm() {
    return (
      <>
        <p>
          Please provide your new email address along with your current login
          credentials to proceed with updating your email/username information.
        </p>
        <FormGroup>
          <Label htmlFor="newEmailAddress">New email address</Label>
          <Input
            id="newEmailAddress"
            name="newEmailAddress"
            maxLength={150}
            onChange={(event) =>
              this.setState({ newEmail: event.target.value })
            }
            placeholder="Enter new email address"
            type="email"
            autoComplete="email"
            required
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="currentUsername">Current email/username</Label>
          <Input
            id="currentUsername"
            name="username"
            onChange={(event) =>
              this.setState({ username: event.target.value })
            }
            placeholder="Enter current email or username"
            type="text"
            autoComplete="username"
            required
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="currentPassword">Password</Label>
          <Input
            id="currentPassword"
            name="password"
            onChange={(event) =>
              this.setState({ password: event.target.value })
            }
            placeholder="Enter current password"
            type="password"
            autoComplete="current-password"
            required
          />
        </FormGroup>
      </>
    );
  }

  renderEmailUpdateActionForm() {
    return (
      <>
        <Button
          color="secondary"
          onClick={() => {
            this.setState({ userEmailModel: false });
          }}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={async () => {
            await callApi(
              `profiles/validate-user-credentials/`,
              'POST',
              {},
              {
                device_uid: localStorage.getItem('device_uid'),
                username: this.state.username,
                password: this.state.password,
                new_email: this.state.newEmail,
              },
            )
              .then((res) => {
                if (res.status === 201 || res.status === 200) {
                  this.setState({
                    url: res.data.email,
                    password_verified: true,
                  });
                }
              })
              .catch((err) => {
                if (err.data?.error) {
                  toast.error(err.data.error);
                } else {
                  toast.error('Username or password incorrect');
                }
              });
          }}
        >
          Proceed
        </Button>
      </>
    );
  }

  renderEmailUpdateOtpActionForm() {
    return (
      <>
        <Button
          color="secondary"
          onClick={() => {
            this.setState({ userEmailModel: false, password_verified: false });
          }}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={async () => {
            void this.verifyOTPForEmailUpdate.bind(this)();
          }}
        >
          Update Email
        </Button>
      </>
    );
  }

  renderNotification() {
    return (
      <>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }

  renderUpdateUserEmailMethods() {
    return (
      <>
        {this.state.userEmailModel && (
          <Modal isOpen={this.state.userEmailModel} size="md">
            <ModalHeader>Update Email Address Confirmation</ModalHeader>
            <ModalBody>
              {!this.state.password_verified && this.renderEmailUpdateForm()}
              {this.state.password_verified && (
                <>
                  <FormGroup>
                    <p>
                      Please enter the 6-digit MFA code sent to your new email
                      address to verify that it has been entered correctly.
                    </p>
                    <Input
                      name="otp"
                      maxLength={6}
                      onChange={(event) =>
                        this.setState({ otp: event.target.value })
                      }
                      placeholder="OTP code"
                      type="text"
                    />
                  </FormGroup>
                </>
              )}
            </ModalBody>
            <ModalFooter>
              {!this.state.password_verified &&
                this.renderEmailUpdateActionForm()}
              {this.state.password_verified &&
                this.renderEmailUpdateOtpActionForm()}
            </ModalFooter>
          </Modal>
        )}
      </>
    );
  }

  render() {
    return (
      <>
        <div className="content">
          <Row>
            <Col md="8">
              <Card>
                <CardHeader>
                  <h5 className="title">Edit Profile</h5>
                </CardHeader>
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="pr-md-1" md="5">
                        <FormGroup>
                          <label>Company </label>
                          <Input
                            name="company"
                            defaultValue={this.state.user.company_name}
                            onChange={(event) =>
                              this.updateUserData(
                                'company_name',
                                event.target.value,
                              )
                            }
                            disabled
                            placeholder="Company"
                            type="text"
                            maxLength={100}
                          />
                        </FormGroup>
                      </Col>

                      <Col className="pl-md-1" md="4">
                        <FormGroup>
                          <label htmlFor="exampleInputEmail1">
                            Email address/Username
                          </label>
                          <Input
                            name="email"
                            maxLength={100}
                            defaultValue={this.state.user.email}
                            placeholder="mike@email.com"
                            disabled
                            type="email"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pl-sm-1" md="1">
                        <FormGroup>
                          <label htmlFor="updateEmail"></label>
                          <Button
                            className="btn-fill"
                            color="primary"
                            onClick={() =>
                              this.setState({
                                userEmailModel: true,
                                password_verified: false,
                              })
                            }
                          >
                            Update Email
                          </Button>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="5">
                        <FormGroup>
                          <label>First Name</label>
                          <Input
                            name="first_name"
                            maxLength={30}
                            defaultValue={this.state.user.first_name}
                            onChange={(event) =>
                              this.updateUserData(
                                'first_name',
                                event.target.value,
                              )
                            }
                            placeholder="First Name"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="5">
                        <FormGroup>
                          <label>Last Name</label>
                          <Input
                            name="last_name"
                            maxLength={30}
                            defaultValue={this.state.user.last_name}
                            onChange={(event) =>
                              this.updateUserData(
                                'last_name',
                                event.target.value,
                              )
                            }
                            placeholder="Last Name"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardHeader>
                  <h5 className="title">MFA Authentication</h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col className="pr-md-1" md="4">
                      <FormGroup>
                        <label>
                          Select desired 2FA(MFA) authentication method
                        </label>
                        <Input
                          type="select"
                          style={{
                            cursor: 'pointer',
                          }}
                          value={this.state.user.authentication_method}
                          onChange={(event) => {
                            this.updateUserData(
                              'authentication_method',
                              event.target.value,
                            );
                            this.setState({
                              mfaModal: true,
                              password_verified: false,
                            });
                          }}
                        >
                          <option
                            style={{
                              color: 'black',
                              backgroundColor: 'white',
                              cursor: 'pointer',
                            }}
                            value={AuthenticationMethod.Email}
                          >
                            via Email
                          </option>
                          <option
                            style={{
                              color: 'black',
                              backgroundColor: 'white',
                              cursor: 'pointer',
                            }}
                            value={AuthenticationMethod.TOTP}
                          >
                            via Authenticator App
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-md-1" md="8">
                      <FormGroup>
                        {this.state.user.authentication_method ===
                          AuthenticationMethod.Email && (
                          <>
                            <p>
                              When logging on, the MFA code will be sent to your
                              email address:{' '}
                              <strong>{this.state.user.email}</strong>
                            </p>
                          </>
                        )}
                        {this.state.user.authentication_method ===
                          AuthenticationMethod.TOTP && (
                          <>
                            <p>Use your phone as your second step to sign in</p>
                          </>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Button
                    className="btn-fill"
                    color="primary"
                    type="submit"
                    onClick={this.updateProfile.bind(this)}
                  >
                    Save
                  </Button>
                </CardFooter>
              </Card>
            </Col>
            <Col md="4">
              <Card className="card-user">
                <CardBody>
                  <CardText />
                  <div className="author">
                    <div className="block block-one" />
                    <div className="block block-two" />
                    <div className="block block-three" />
                    <div className="block block-four" />
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img alt="..." className="avatar" src={SP360IconLogo} />
                      <h5 className="title">
                        {this.state.user.first_name} {this.state.user.last_name}
                      </h5>
                    </a>
                    <p className="description">{this.state.user.position}</p>
                  </div>
                  <div className="card-description"></div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderUpdateMFAMethods()}
        {this.renderUpdateUserEmailMethods()}
        {this.renderNotification()}
      </>
    );
  }
}

// Functional wrapper keeps the original exported name
const UserProfile = () => {
  const companyId = useAtomValue(companyIdAtom);
  if (!companyId || companyId === -1) return <LoadingScreen />;

  return <UserProfileInner companyId={companyId} />;
};

export default UserProfile;
